(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = (window.THEME && THEME.moneyFormat) || '{{amount}}';
    var v = (cents / 100);
    var noDec = Math.round(v).toLocaleString('en-US');
    var withDec = v.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) return k.indexOf('comma_separator') > -1 ? noDec.replace(/,/g, '.') : noDec;
      if (k.indexOf('comma_separator') > -1) return withDec.replace(/,/g, ' ').replace('.', ',');
      return withDec;
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- header drawer ---------- */
  var drawer = $('#menu-drawer');
  $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.add('open'); }); });
  $$('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { drawer && drawer.classList.remove('open'); }); });

  /* ---------- generic sliders with dots ---------- */
  function initSlider(track) {
    var dotsEl = track.parentNode.querySelector('[data-dots]');
    var items = track.children;
    if (!items.length) return;
    if (dotsEl) {
      dotsEl.innerHTML = '';
      for (var i = 0; i < items.length; i++) dotsEl.appendChild(document.createElement('i'));
    }
    function current() {
      var w = items[0].getBoundingClientRect().width + 14;
      return Math.min(items.length - 1, Math.round(Math.abs(track.scrollLeft) / w));
    }
    function paint() {
      var k = current();
      if (dotsEl) $$('i', dotsEl).forEach(function (d, j) { d.classList.toggle('on', j === k); });
      var c = track.parentNode.querySelector('[data-counter]');
      if (c) c.textContent = ('0' + (k + 1)).slice(-2) + ' / ' + ('0' + items.length).slice(-2);
    }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
    paint();
    function go(dir) {
      var w = items[0].getBoundingClientRect().width + 14;
      // RTL: positive "next" means scroll left
      track.scrollBy({ left: -dir * w, behavior: 'smooth' });
    }
    var nx = track.parentNode.querySelector('[data-next]'), pv = track.parentNode.querySelector('[data-prev]');
    if (nx) nx.addEventListener('click', function () { go(1); });
    if (pv) pv.addEventListener('click', function () { go(-1); });
    var auto = parseInt(track.getAttribute('data-autoplay') || '0', 10);
    if (auto > 0) {
      setInterval(function () {
        if (document.hidden) return;
        var max = track.scrollWidth - track.clientWidth;
        if (Math.abs(track.scrollLeft) >= max - 5) track.scrollTo({ left: 0, behavior: 'smooth' });
        else go(1);
      }, auto * 1000);
    }
  }
  $$('[data-slider]').forEach(initSlider);

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('.gallery__slides', g);
    var thumbs = $$('.gallery__thumbs button', g);
    if (!track) return;
    function goTo(i) {
      var slide = track.children[i]; if (!slide) return;
      track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i); }); });
    track.addEventListener('scroll', function () {
      var w = track.clientWidth || 1, k = Math.round(Math.abs(track.scrollLeft) / w);
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === k); });
      $$('.gallery__dots i', g).forEach(function (d, j) { d.classList.toggle('on', j === k); });
    }, { passive: true });
    var nx = $('.gallery__nav--next', g), pv = $('.gallery__nav--prev', g);
    if (nx) nx.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
    if (pv) pv.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
    g.goToMedia = function (mediaId) {
      var idx = -1;
      $$('.gallery__slide', g).forEach(function (s, i) { if (s.getAttribute('data-media-id') === String(mediaId)) idx = i; });
      if (idx > -1) goTo(idx);
    };
  });

  var sticky = $('[data-sticky-buy]');

  /* ---------- ad attribution (kept for the order) ---------- */
  try {
    var qs = new URLSearchParams(location.search), keep = {};
    ['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','ttclid','gclid'].forEach(function (k) { if (qs.get(k)) keep[k] = qs.get(k); });
    if (Object.keys(keep).length) { keep.landing = location.pathname; sessionStorage.setItem('cod_attr', JSON.stringify(keep)); }
  } catch (x) {}

  /* ---------- product form: offers + COD ---------- */
  $$('[data-product]').forEach(function (root) {
    var offers = $$('.offer', root);
    var totalEl = $('[data-total]', root);
    var priceEl = $('[data-price-now]', root);
    var wasEl = $('[data-price-was]', root);
    var stickyPrice = $('[data-sticky-price]');
    var qtyInput = $('[data-qty]', root);
    var gallery = $('[data-gallery]', root);

    function selected() { return $('input[name="id"]:checked', root) || $('input[name="id"]', root); }
    function qty() { return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1; }
    function refresh() {
      var i = selected(); if (!i) return;
      offers.forEach(function (o) { o.classList.toggle('is-active', o.contains(i)); });
      var p = parseInt(i.getAttribute('data-price'), 10) || 0;
      var c = parseInt(i.getAttribute('data-compare') || '0', 10);
      if (totalEl) totalEl.textContent = money(p * qty());
      if (priceEl) priceEl.textContent = money(p);
      if (stickyPrice) stickyPrice.textContent = money(p);
      if (wasEl) { wasEl.textContent = c > p ? money(c) : ''; wasEl.hidden = !(c > p); }
      var mid = i.getAttribute('data-media');
      if (mid && gallery && gallery.goToMedia) gallery.goToMedia(mid);
    }
    offers.forEach(function (o) { o.addEventListener('change', refresh); });
    $$('[data-qty-btn]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, qty() + parseInt(b.getAttribute('data-qty-btn'), 10));
        refresh();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', refresh);
    refresh();

    var form = $('[data-cod]', root);
    if (!form) return;
    var err = $('[data-cod-err]', form);
    var btn = $('[type="submit"]', form);
    var btnText = btn ? btn.innerHTML : '';
    function fail(msg, field) {
      err.textContent = msg;
      if (field) { field.classList.add('is-error'); field.focus(); }
    }
    $$('.field', form).forEach(function (f) { f.addEventListener('input', function () { f.classList.remove('is-error'); err.textContent = ''; }); });

    var startedAt = Date.now();
    var success = $('[data-cod-success]', root);

    function attribution() {
      var a = {};
      try { a = JSON.parse(sessionStorage.getItem('cod_attr') || '{}'); } catch (x) {}
      return a;
    }

    function showSuccess(res, v, qtyN, price) {
      var total = price * qtyN;
      if (success) {
        var set = function (k, val) { var el = $('[data-s="' + k + '"]', success); if (el) el.textContent = val; };
        set('order', res.order || '—');
        set('offer', v.getAttribute('data-title') || '');
        set('total', money(total));
        set('phone', form.elements.cod_phone.value);
        if (res.duplicate) { var d = $('[data-s="dup"]', success); if (d) d.hidden = false; }
        form.hidden = true;
        success.hidden = false;
        var box = form.closest('.order-box'); if (box) box.classList.add('is-done');
        $$('.offers .offer', root).forEach(function (o) { o.classList.add('is-disabled'); });
        if (sticky) sticky.remove();
        success.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (!res.duplicate && res.order) {
        var value = total / 100, cur = (window.THEME && THEME.currencyIso) || 'DZD', vid = String(v.value);
        try { if (window.fbq) fbq('track', 'Purchase', { value: value, currency: cur, content_ids: [vid], content_type: 'product', num_items: qtyN }, { eventID: res.order }); } catch (x) {}
        try { if (window.ttq) ttq.track('CompletePayment', { value: value, currency: cur, contents: [{ content_id: vid, quantity: qtyN }] }, { event_id: res.order }); } catch (x) {}
        try { if (window.gtag) gtag('event', 'purchase', { transaction_id: res.order, value: value, currency: cur }); } catch (x) {}
        try { if (window.snaptr) snaptr('track', 'PURCHASE', { price: value, currency: cur, transaction_id: res.order }); } catch (x) {}
      }
      if (THEME.thankYouUrl && res.order) {
        setTimeout(function () { location.href = THEME.thankYouUrl + (THEME.thankYouUrl.indexOf('?') > -1 ? '&' : '?') + 'order=' + encodeURIComponent(res.order); }, 1200);
      }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      err.textContent = '';
      var f = form.elements;
      var name = (f.cod_name.value || '').trim().replace(/\s+/g, ' ');
      var phone = (f.cod_phone.value || '').replace(/[\s.\-()]/g, '').replace(/^\+?213/, '0').replace(/^00213/, '0');
      if (/^[567]\d{8}$/.test(phone)) phone = '0' + phone;
      var wilaya = f.cod_wilaya.value;
      var commune = f.cod_commune ? f.cod_commune.value.trim() : '';
      var address = f.cod_address ? f.cod_address.value.trim() : '';
      var shipEl = form.querySelector('input[name="cod_ship"]:checked');
      var shipType = shipEl ? shipEl.value : 'home';
      var shipLabel = shipType === 'office' ? 'للمكتب' : 'للمنزل';
      if (name.length < 3) return fail('يرجى كتابة الاسم الكامل', f.cod_name);
      if (!/^0[567]\d{8}$/.test(phone)) return fail('رقم الهاتف غير صحيح (مثال: 0555123456)', f.cod_phone);
      if (!wilaya) return fail('يرجى اختيار الولاية', f.cod_wilaya);
      if (f.cod_commune && f.cod_commune.required && !commune) return fail('يرجى كتابة البلدية', f.cod_commune);

      var v = selected(); if (!v) return fail('يرجى اختيار العرض');
      var qtyN = qty(), price = parseInt(v.getAttribute('data-price'), 10) || 0;
      btn.disabled = true; btn.textContent = 'جاري تسجيل الطلب...';
      var restore = function () { btn.disabled = false; btn.innerHTML = btnText; };

      /* ---- one-step order (endpoint configured) ---- */
      if (THEME.codEndpoint) {
        fetch(THEME.codEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            variantId: v.value, quantity: qtyN, name: name, phone: phone, wilaya: wilaya, commune: commune,
            address: address, shipType: shipType, offerTitle: v.getAttribute('data-title') || '',
            website: f.website ? f.website.value : '', elapsedMs: Date.now() - startedAt, attribution: attribution()
          })
        })
          .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
          .then(function (res) {
            if (res && res.ok) { showSuccess(res, v, qtyN, price); return; }
            restore();
            var fieldMap = { name: f.cod_name, phone: f.cod_phone, wilaya: f.cod_wilaya };
            fail((res && res.error) || 'صار خطأ، حاولي مرة أخرى أو تواصلي معنا على واتساب', res && fieldMap[res.field]);
          })
          .catch(function () { restore(); fail('مشكل في الاتصال بالإنترنت، حاولي مرة أخرى'); });
        return;
      }

      /* ---- fallback: cart + Shopify checkout ---- */
      var props = { 'العرض': v.getAttribute('data-title') || '' };
      var attrs = { 'الاسم': name, 'الهاتف': phone, 'الولاية': wilaya, 'البلدية': commune, 'العنوان': address, 'نوع التوصيل': shipLabel };
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function () {
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(v.value), quantity: qtyN, properties: props }] }) });
        })
        .then(function (r) { if (!r.ok) throw new Error('add'); return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: attrs, note: name + ' - ' + phone + ' - ' + wilaya + ' - ' + commune + ' - ' + address }) }); })
        .then(function () {
          try { if (window.fbq) fbq('track', 'InitiateCheckout'); } catch (x) {}
          try { if (window.ttq) ttq.track('InitiateCheckout'); } catch (x) {}
          if (THEME.after === 'cart') { location.href = '/cart'; return; }
          var parts = name.split(' ');
          var q = [
            'checkout[shipping_address][first_name]=' + encodeURIComponent(parts.shift() || name),
            'checkout[shipping_address][last_name]=' + encodeURIComponent(parts.join(' ') || '-'),
            'checkout[shipping_address][phone]=' + encodeURIComponent(phone),
            'checkout[shipping_address][city]=' + encodeURIComponent(commune || wilaya),
            'checkout[shipping_address][address1]=' + encodeURIComponent(address || commune || wilaya),
            'checkout[shipping_address][address2]=' + encodeURIComponent(wilaya),
            'checkout[shipping_address][country]=DZ'
          ].join('&');
          location.href = '/checkout?' + q;
        })
        .catch(function () { restore(); fail('صار خطأ، حاولي مرة أخرى أو تواصلي معنا على واتساب'); });
    });
  });

  /* ---------- sticky buy bar ---------- */
  var anchor = $('[data-order-anchor]');
  if (sticky && anchor) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.classList.toggle('show', !e.isIntersecting && e.boundingClientRect.top < 0); });
    });
    io.observe(anchor);
  }

  /* ---------- countdown (resets daily at midnight) ---------- */
  $$('[data-countdown]').forEach(function (cd) {
    var sp = $$('span', cd);
    var pad = function (x) { return ('0' + x).slice(-2); };
    function tick() {
      var n = new Date(), m = new Date(n); m.setHours(24, 0, 0, 0);
      var s = Math.floor((m - n) / 1000);
      sp[0].textContent = pad(Math.floor(s / 3600)); sp[1].textContent = pad(Math.floor(s % 3600 / 60)); sp[2].textContent = pad(s % 60);
    }
    tick(); setInterval(tick, 1000);
  });

  /* ---------- counters + fade-up ---------- */
  if ('IntersectionObserver' in window) {
    var so = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; so.unobserve(el);
        if (el.hasAttribute('data-count')) {
          var raw = el.getAttribute('data-count'), t = parseFloat(raw), dec = (raw.split('.')[1] || '').length, suf = el.getAttribute('data-suffix') || '', st = null;
          if (isNaN(t)) return;
          (function step(ts) { if (!st) st = ts; var p = Math.min((ts - st) / 1400, 1); el.textContent = (t * p).toFixed(dec) + suf; if (p < 1) requestAnimationFrame(step); })(performance.now());
        } else el.classList.add('in');
      });
    }, { threshold: .4 });
    $$('[data-count], .fade-up').forEach(function (el) { so.observe(el); });
  } else {
    $$('.fade-up').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- video reviews ---------- */
  $$('.vid').forEach(function (card) {
    var v = $('video', card), b = $('.vid__snd', card);
    if (!v || !b) return;
    b.addEventListener('click', function () { v.muted = !v.muted; b.textContent = v.muted ? '🔇 شغّلي الصوت' : '🔊 الصوت شغال'; v.play(); });
  });
  if ('IntersectionObserver' in window) {
    var vo = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { var p = e.target.play(); if (p && p.catch) p.catch(function () {}); } else e.target.pause(); }); }, { threshold: .6 });
    $$('.vid video, video[data-autoplay-view]').forEach(function (v) { vo.observe(v); });
  }

  /* ---------- review image lightbox ---------- */
  var lb = $('#lightbox');
  if (lb) {
    $$('[data-zoom]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); $('img', lb).src = a.getAttribute('href'); lb.classList.add('open'); });
    });
    lb.addEventListener('click', function () { lb.classList.remove('open'); });
  }

  /* ---------- cart qty ---------- */
  $$('[data-cart-qty]').forEach(function (inp) {
    inp.addEventListener('change', function () { inp.form.submit(); });
  });
})();
